/*
 * Copyright 2010-2016 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

import utils from '../apiGatewayCore/utils';
import { apiGatewayClientFactory } from '../apiGatewayCore/apiGatewayClient.js'
import uritemplate from "../apiGatewayCore/url-template"

var apigClientFactory = {};
apigClientFactory.newClient = function (config, invokeUrl) {
    var apigClient = { };
    if(config === undefined) {
        config = {
            accessKey: '',
            secretKey: '',
            sessionToken: '',
            region: '',
            apiKey: undefined,
            defaultContentType: 'application/json',
            defaultAcceptType: 'application/json'
        };
    }
    if(config.accessKey === undefined) {
        config.accessKey = '';
    }
    if(config.secretKey === undefined) {
        config.secretKey = '';
    }
    if(config.apiKey === undefined) {
        config.apiKey = '';
    }
    if(config.sessionToken === undefined) {
        config.sessionToken = '';
    }
    if(config.region === undefined) {
        config.region = 'us-east-1';
    }
    //If defaultContentType is not defined then default to application/json
    if(config.defaultContentType === undefined) {
        config.defaultContentType = 'application/json';
    }
    //If defaultAcceptType is not defined then default to application/json
    if(config.defaultAcceptType === undefined) {
        config.defaultAcceptType = 'application/json';
    }

    
    // extract endpoint and path from url
    var endpoint = /(^https?:\/\/[^\/]+)/g.exec(invokeUrl)[1];
    var pathComponent = invokeUrl.substring(endpoint.length);

    var sigV4ClientConfig = {
        accessKey: config.accessKey,
        secretKey: config.secretKey,
        sessionToken: config.sessionToken,
        serviceName: 'execute-api',
        region: config.region,
        endpoint: endpoint,
        defaultContentType: config.defaultContentType,
        defaultAcceptType: config.defaultAcceptType
    };

    var authType = 'NONE';
    if (sigV4ClientConfig.accessKey !== undefined && sigV4ClientConfig.accessKey !== '' && sigV4ClientConfig.secretKey !== undefined && sigV4ClientConfig.secretKey !== '') {
        authType = 'AWS_IAM';
    }

    var simpleHttpClientConfig = {
        endpoint: endpoint,
        defaultContentType: config.defaultContentType,
        defaultAcceptType: config.defaultAcceptType
    };

    var apiGatewayClient = apiGatewayClientFactory.newClient(simpleHttpClientConfig, sigV4ClientConfig);
    
    
    
    apigClient.stripeSessionPost = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }
        
        utils.assertParametersDefined(params, [], ['body']);
        
        var stripeSessionPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/session').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };
        
        
        return apiGatewayClient.makeRequest(stripeSessionPostRequest, authType, additionalParams, config.apiKey);
    };

    apigClient.stripeSessionCardPost = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeSessionCardPostRequest = {
            verb: 'post'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/session/card').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeSessionCardPostRequest, authType, additionalParams, config.apiKey);
    };


    apigClient.stripeSubscriptionPut = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeSubscriptionPutRequest = {
            verb: 'put'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/subscription').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeSubscriptionPutRequest, authType, additionalParams, config.apiKey);
    };

    apigClient.stripeSubscriptionDelete = function (params, body, additionalParams) {
        if(additionalParams === undefined) { additionalParams = {}; }

        utils.assertParametersDefined(params, [], ['body']);

        var stripeSubscriptionDeleteRequest = {
            verb: 'delete'.toUpperCase(),
            path: pathComponent + uritemplate('/stripe/subscription').expand(utils.parseParametersToObject(params, [])),
            headers: utils.parseParametersToObject(params, []),
            queryParams: utils.parseParametersToObject(params, []),
            body: body
        };


        return apiGatewayClient.makeRequest(stripeSubscriptionDeleteRequest, authType, additionalParams, config.apiKey);
    };
    

    return apigClient;
};

export default apigClientFactory